import { Box, } from '@mui/material';

interface MainSectionProps {
  children: React.ReactNode;
  paddingAmount?: string | number;
  direction?: 'flex-start' | 'center' | 'flex-end';
}

const sectionStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    backgroundColor: "#111111",
    minHeight: '100vh',
    width: '100%',
    position: 'relative', 
    zIndex: 3,
    color: 'white',
};


export default function MainSection({children, paddingAmount, direction}: MainSectionProps) {
    return (
        <Box
            sx={{
                ...sectionStyles,
                position: 'relative',
                justifyContent: direction || 'center',
                padding: paddingAmount || '0',
            }}
        >
            {children}
        </Box>
    );
}